import { render } from "./AuTabPanel.vue?vue&type=template&id=5c785fe6&scoped=true"
import script from "./AuTabPanel.vue?vue&type=script&lang=js"
export * from "./AuTabPanel.vue?vue&type=script&lang=js"

import "./AuTabPanel.vue?vue&type=style&index=0&id=5c785fe6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c785fe6"]])

export default __exports__